import { Modal, Button, Row, Col } from "antd";
import Images from "./../../../../asset/exportImages";
import { trackProductEvent } from '../../../../lib/trackingService';

function MDWarningCreate({ handelCanCel, create }) {

  return (
    <>
      <Modal
        footer={false}
        open={true}
        centered={false}
        closable={false}
        style={{ maxWidth: 329 }}
      >
        <Row gutter={[15, 15]}>
          <Col xs={24}>
            <div style={{ textAlign: 'center' }}>
              <img width={"60px"} height={"60px"} src={Images.ICWarning} />
            </div>
          </Col>
          <Col xs={24}>
            <div style={{ fontSize: 16, color: '#343A40', textAlign: 'center' }}>
              Bạn <b>không thể thay đổi</b> thông tin <br/> đăng ký sau khi thanh toán. Hãy<br/> kiểm tra thông tin trước khi <b>Xác nhận</b>
            </div>
          </Col>
          <Col xs={24}>
            <div style={{ textAlign: 'center' }}>
              <b style={{ fontSize: 18 }}>Bạn có muốn tiếp tục không?</b>
            </div>
          </Col>
          <Col xs={12}>
            <Button
              onClick={() => handelCanCel()}
              style={{ backgroundColor: '#F0F2F5', height: 44, color: '#343A40', width: '100%', boxShadow: 'none', fontWeight: 500, borderRadius: 8, fontSize: 15, border: '0.5px solid #D2D2D2' }}
              type="primary">
              Thoát
            </Button>
          </Col>
          <Col xs={12}>
            <Button
              onClick={() => { 
                trackProductEvent("product_review_confirmed", {
                  order_id: null,
                });
                create();
                handelCanCel();
              }}
              style={{ backgroundColor: '#009B4B', height: 44, width: '100%', color: '#fff', fontWeight: 500, borderRadius: 8, fontSize: 15 }}
              type="primary">
              Xác nhận
            </Button>
          </Col>
        </Row>
      </Modal >
    </>
  );
}

export default MDWarningCreate;
